import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { useOrgDefaultCurrency } from './useOrgDefaultCurrency';

/**
 * THE two currencies the app knows, and which one to use where (decided in
 * feedback round 3, 2 Nov 2026: currency is per user).
 *
 *   useDisplayCurrency() - the signed-in user's own currency: how the firm's
 *       money is shown to them, and what new matters and rates they create
 *       default to. Their Preferences choice, else the firm default, else EUR.
 *       A matter keeps its own billing currency - amounts that belong to a
 *       matter are shown in it, not converted.
 *
 *   usePriceCurrency() - what the firm pays PONS in: the licence price
 *       currency from /licensing/my-access. Every plan, add-on and seat price.
 *       Never the user's preference - a Norwegian partner does not change what
 *       the firm is invoiced in.
 *
 * Both return a lowercase ISO 4217 code, like the rest of the app.
 */
export const useDisplayCurrency = (): string => {
  const own = useSelector((s: RootState) => s.user?.userInfo?.preferences?.general_settings?.currency);
  const { defaultCurrency } = useOrgDefaultCurrency();
  return String(own || defaultCurrency || 'eur').toLowerCase();
};

export const usePriceCurrency = (): string | null => {
  const code = useSelector((s: RootState) => (s.license?.access as any)?.price_currency);
  return code ? String(code).toLowerCase() : null;
};
